module.exports = __webpack_public_path__ + "static/media/portfoli_banner3_right_img2.73f4ee93.png";